import { useAuth } from "@/contexts/AuthContext";
import { DeviceLimitModal } from "@/components/DeviceLimitModal";

/** Global device limit enforcement – rendered at app root level */
const GlobalDeviceLimit = () => {
  const { deviceLimit, dismissDeviceLimit, removeDeviceAndRetry } = useAuth();

  return (
    <DeviceLimitModal
      isOpen={deviceLimit.isOpen}
      onClose={dismissDeviceLimit}
      sessions={deviceLimit.sessions}
      onRemoveDevice={async (sessionId: string) => {
        await removeDeviceAndRetry(sessionId);
        return true;
      }}
      onRetry={() => {
        // Retry is handled inside removeDeviceAndRetry
      }}
    />
  );
};

export default GlobalDeviceLimit;
